<template>
  <div class="login">
    <el-button type="primary" plain style="top: -10px;right: -10px;position: absolute;top: 10px;right: 10px;" @click="close">关闭机器</el-button>
    <div class="welcome" style="position: relative;text-align: center;">
      <span style="color: #ffffff;
    top: 10%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    font-size:60px">万宏集团食堂系统登录</span>
    </div>
    <div class="login-form" style="width:80%;margin-left: 11%;">
      <el-form ref="user" :model="user">
        <el-form-item class="login-inp">
          <el-input style="font-size:40px;"
            v-model="user.cardId"
            placeholder="请输入卡号"
            @keyup.enter.native="doLogin"
            type="password"
            v-fo
            ref="input"
            @blur="blur"
            class="card"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-inp">
          <el-button class="loginBtn" style="width: 100%;height:60px" ri type="primary" @click="doLogin"
            >登        录</el-button
          >
        </el-form-item>
        <!-- <el-form-item class="login-inp">
          <el-button plain style="width: 100%" type="primary" @click="register"
            >注册/修改</el-button
          >
        </el-form-item> -->
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  //单页面中不支持前面的data:{}方式
  data() {
    //相当于以前的function data(){},这是es5之前的写法，新版本可以省略掉function
    return {
      user: {
        cardId: ""
      },
    };
  },
  created: function (){
    this.$nextTick(()=>{
this.$refs['input'].focus()

});
  },
  methods: {
    blur(){
      this.$refs['input'].focus()
    },
    doLogin() {
      //一点击登录按钮，这个方法就会执行
      const loading = this.$loading();
      var that = this;
      this.axios
        .post("/User/CardLogin", {
          cardId: this.user.cardId
        })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              window.sessionStorage.setItem(
                "userToken",
                response.data.data.userToken
              );
              window.sessionStorage.setItem(
                "userName",
                response.data.data.name
              );
              //that.$route.meta.$keepAlive = false;
              that.$router.replace("/ClientIndex?timestamp=" + new Date().getTime());
              //window.location.replace("/ClientIndex?timestamp=" + new Date().getTime());
            } else {
              that.$message.error(response.data.message);
              that.user.cardId=''
            }
          } else {
            that.$message.error("请检查网络设置");
          }
          loading.close();
        });
    },
    close(){
      //调用winform关机方法
      Formium.external.form.closeWindow();
    }
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: url(../../assets/bg.png) no-repeat;
  background-size: cover;
  position: fixed;
  z-index: -10;
}
.welcome {
  width: 100%;
  margin: 10% 0
}
.welcome img {
  width: 100%;
}
.login-inp {
  margin: 0 30px 15px 30px;

  border-radius: 25px;
}
.confirm {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 5px 4px;
  width: 70%;
  font-size: 14px;
  font-family: "Microsoft soft";
  margin-top: 5px;
  margin-bottom: 5px;
  float: left;
}
.confirm:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.label {
  padding: 5px 4px;
  width: 20%;
  font-size: 14px;
  font-family: "Microsoft soft";
  margin-top: 5px;
  margin-bottom: 5px;
  float: left;

}
.item{
  width: 100%;
  float: left;
}

</style>
<style>
.winClass {
  width: 90%;
}
.card .el-input__inner{
          height: 70px;
        }
.loginBtn .el-button {
  font-size: 30px;
}

</style>


// WEBPACK FOOTER //
// src/components/Login/Client.vue